// @ts-nocheck

import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'
import { DateRangePicker } from '../DateRangePicker'

class LogFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: props.from || null,
      endDate: props.to || null,
      date: null,
      focused: null
    }

    this.onDatesChange = this.onDatesChange.bind(this)
  }

  getFilteredData = (logs, { startDate, endDate }) => {
    let { data } = this.props

    // Block after
    if (startDate) {
      data = data.filter((log) => {
        return (
          startDate
            .startOf('day')
            .diff(dayjs(log.timeLogged).startOf('day'), 'days') <= 0
        )
      })
    }

    // Block before
    if (endDate) {
      data = data.filter((log) => {
        return (
          endDate
            .startOf('day')
            .diff(dayjs(log.timeLogged).startOf('day'), 'days') >= 0
        )
      })
    }

    return data
  }

  formatToDate(day) {
    return day.format('DD-MM-YYYY')
  }

  onDatesChange = ({ startDate, endDate }) => {
    const { maximumNights, logs } = this.props
    const end =
      endDate && endDate.diff(startDate, 'days') > maximumNights
        ? dayjs(startDate).add(maximumNights - 1, 'days')
        : endDate

    this.setState({ startDate, endDate: end })

    if (this.props.onChange) {
      this.props.onChange(
        this.getFilteredData(logs, { startDate, endDate: end })
      )
    }
    if (this.props.onNewDates) {
      this.props.onNewDates({ startDate, endDate: end })
    }
  }

  render() {
    const { startDate, endDate } = this.state
    const { blockFuture, maximumNights } = this.props

    return (
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={this.onDatesChange}
        blockFuture={blockFuture}
        maximumNights={maximumNights}
      />
    )
  }
}

LogFilter.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  maximumNights: PropTypes.number,
  blockFuture: PropTypes.bool,
  blockDatesWithNoData: PropTypes.bool
}

export default LogFilter
